<div class="container container-xl container-xxxl">
  <div class="row">
    <div class="col">
      <app-page-organizations [isDetailedView]="false"></app-page-organizations>
    </div>
  </div>
</div>
